import {AbstractControl, AsyncValidatorFn, UntypedFormGroup, ValidationErrors} from '@angular/forms';
import {Observable, of} from 'rxjs';
import {ApiService} from '../../../_services/api.service';
import {catchError, map} from 'rxjs/operators';
import {Parcel} from '../../../_models/parcel';
import {CustomFormControl} from '../components/controls/CustomFormControl';
import {FileOnlineViewModel} from '../FileOnlineViewModel';

export function ainValidatorAndPatcher(formGroup: UntypedFormGroup, apiService: ApiService, viewModel: FileOnlineViewModel): AsyncValidatorFn {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    if (!(control instanceof CustomFormControl)) {
      return;
    }

    const ain = control.value.replace(/-/g, '');
    if (ain.length !== 10) {
      for (const patchPath of control.element.patcher.targets) {
        formGroup.get(patchPath.targetControlId)?.setValue('');
      }

      return of({ invalidAin: `No address associated with the given AIN: ${ain}` });
    }

    const cachedParcel = viewModel.getCachedParcel(ain);

    if (cachedParcel) {
      return of(handleAinPatch(control, cachedParcel, formGroup));
    }

    return apiService.getParcel(ain).pipe(
      map(fullParcel => {
        if (fullParcel && fullParcel.Parcel) {
          viewModel.addParcel(fullParcel.Parcel);
          viewModel.cacheParcel(ain, fullParcel.Parcel);
          return handleAinPatch(control, fullParcel?.Parcel, formGroup);
        }

        return { invalidAin: true };
      }),
      catchError((error: any) => {
        console.error(error);
        return of({ invalidAin: true});
      })
    );
  };
}

function handleAinPatch(control: CustomFormControl, parcel: Parcel, formGroup: UntypedFormGroup): Observable<ValidationErrors | null> {
  const patcher = control.element.patcher;

  for (const patchPath of patcher.targets) {
    if (patchPath.sourceField.length === 0) {
      const address = extractAddressToString(parcel);
      formGroup.get(patchPath.targetControlId)?.setValue(address);
    } else {
      const addressField = parcel[patchPath.sourceField];
      formGroup.get(patchPath.targetControlId)?.setValue(addressField);
    }
  }

  return null;
}

export function extractAddressToString(parcel: Parcel): string {
  return parcel.SitusStreet + ', ' + insertComma(parcel.SitusCity) + ' ' + parcel.SitusZipCode;
}

function insertComma(str: string): string {
  const lastSpaceIndex = str.lastIndexOf(' ');
  if (lastSpaceIndex === -1) { return str; } // No space found
  return str.slice(0, lastSpaceIndex) + ', ' + str.slice(lastSpaceIndex + 1);
}
